/**
 * This file is auto-generated (gulp api-gen-def)
 */
/* eslint-disable */
// language=ts
export const definitions = `
  declare class Notifier {
    public static init(
    showMessageBox: ShowMessageBox,
    notify: NotyNotify,
    ring: NotyRing
  ): void;
    public static error(message: string): void;
    public static warn(message: string): void;
    public static success(message: string): void;
    public static show(
    title: string,
    message: string,
    onClick: () => void = Util.noop
  ): void;
    public static playSound(soundNumber?: number): void;
  }

  declare class Current {
    public static get user(): UserObj;
    public static get project(): Item;
    public static get board(): Item;
    public static get chat(): Item;
    public static get company(): Item;
    public static onProjectChange?: (oldProject: Item, newProject: Item) => void
    public static onBeforeScriptUnload?: (oldBoard?: Item, newBoard?: Item) => void
    public static onBoardChange?: (oldBoard?: Item, newBoard?: Item) => void
    public static onChatChange?: (oldChat: Item, newChat: Item) => void
    public static override afterLoad(): void;
    public static override beforeUnload(): void;
  }

  declare class Items {
    public static get(id: string): Item | undefined;
    public static onAdd?: (newObject: Item) => boolean
    public static onBeforeAdd?: (location: Item, name: string) => boolean
    public static onRename?: (item: Item, newName: string) => boolean
    public static onDelete?: (item: Item) => boolean
    public static onChangeArchived?: (item: Item) => boolean
    public static onChangeDeadline?: (item: Item) => boolean
    public static onClick?: (item: Item) => boolean
    public static onList?: (item: Item, items: Item[]) => Item[]
    public static onMove?: (item: Item, from: Item, to: Item) => boolean
    public static onUpdate?: (item: Item) => void
    public static isHidden?: (item: Item) => boolean
    public static allowDelete?: (item: Item) => boolean
    public static allowAdd?: (item: Item) => boolean
    public static allowRename?: (item: Item) => boolean
    public static allowDrag?: (item: Item) => boolean
    public static onUpdateSubtasksList?: (item: Item) => boolean
    public static override afterLoad(): void;
    public static override beforeUnload(): void;
  }

  declare type ItemType =
    | 'Company'
    | 'Project'
    | 'Board'
    | 'Column'
    | 'Task'
    | 'Subtask'
  declare type ItemGetUi = (
    companyId: string,
    itemId: string
  ) => UIElement
  declare type ItemOpen = (
    itemId: string,
    type: ItemType,
    findHub: (id: string) => Hub
  ) => void
  declare type TaskLocation = {
    column?: string
    board?: string
    project?: string
  }

  declare class Item {
    public id: string
    public static init(getUi: ItemGetUi, open: ItemOpen);
    public get type(): ItemType;
    public get name(): string;
    public set name(value: string);
    public get deleted(): boolean;
    public set deleted(value: boolean);
    public get timestamp(): number;
    public get path(): string;
    public get ui(): UIElement;
    public open(): void;
    public move(newParent: Item): void;
    public find(name?: string): Item | undefined;
    public up(): Item | undefined;
    public list(): Item[];
    public add(name: string): Item;
    public getData(key: string): unknown;
    public setData(key: string, json: unknown): void;
    public triggerUpdate(allUsers = false): void;
    public isArchived(): boolean;
    public isCompleted(): boolean;
    public setCompleted(value: boolean): void;
    public getAllParentTasks(force?: boolean): Item[] | undefined;
    public getTaskLocations(): TaskLocation | undefined;
    public getAssignedUsers(): string[] | undefined;
    public setAssignedUsers(users: string[]): void;
    public isTaskCompleted(): boolean;
    public setTaskCompleted(value: boolean): void;
    public getTaskCompletionTime(): number;
    public setMirror(columns: Item[]): void;
    public isMirror(): boolean;
    public isReport(): boolean;
    public listMirrored(): Item[];
  }

  declare type DeadLine = {
    blockedPoints: RangePoint[]
    withTime: boolean
    timestamp: number
    startDate?: number
    deadline?: number
  }

  declare class Stickers {
    public static getAll(): StickerObj[];
    public static get(name: string): StickerObj | undefined;
    public static create(name: string): StickerObj;
    public static pin(task: Item, sticker: StickerObj, value: string): void;
    public static unpin(task: Item, sticker: StickerObj): void;
    public static isPinned(task: Item, sticker: StickerObj): boolean;
    public static getValue(task: Item, sticker: StickerObj): string | undefined;
    public static getDeadline(task: Item): DeadLine | undefined;
    public static getDeadlineHistory(
    task: Item
  ): Array<{withTime: boolean; timestamp: number; user: UserObj}> | undefined;
    public static getDeadlineLinks(task: Item): string[];
    public static setDeadline(
    task: Item,
    timestamp?: number,
    withTime?: boolean,
    startDate?: number,
    byYougileUser?: boolean
  ): void;
    public static getFilterValue(board: Item, sticker: StickerObj): string[];
    public static getAllFilters(board: Item): StickerObj[];
    public static setFilter(board: Item, sticker: StickerObj, value: string): void;
    public static removeFilter(board: Item, sticker: StickerObj): void;
    public static getAllInBoard(board: Item): StickerObj[];
    public static isInBoard(board: Item, sticker: StickerObj): boolean;
    public static addToBoard(board: Item, sticker: StickerObj): void;
    public static removeFromBoard(board: Item, sticker: StickerObj): void;
    public static onBoardFilterChange?: () => void
    public static onPin?: (task: Item, sticker: StickerObj, value: any) => boolean
    public static onUnpin?: (task: Item, sticker: StickerObj) => boolean
  }

  declare class StickerObj {
    public id: string
    public get name(): string;
    public set name(value: string);
    public get type(): string;
    public get states(): string[];
    public addState(name: string): void;
    public removeState(name: string): void;
    public getData(name: string): unknown;
    public setData(name: string, data: unknown): void;
    public getHistory(task: Item): unknown[];
    public clearHistory(task: Item): void;
    public changeTime(task: Item, time: string): void;
    public start(task: Item, time: string): void;
    public stop(task: Item): void;
  }

  declare class MessageObj {
    public get timestamp(): number;
    public get from(): UserObj;
    public set from(val: UserObj);
    public get text(): string;
    public set text(val: string);
    public get deleted(): boolean;
    public set deleted(val: boolean);
    public get ui(): UIElement;
    public getTask(): Item;
    public getData(): unknown;
    public setData(val: unknown): void;
    public static fromMessageAndHub(msg: ChatMessage, hub: Hub): MessageObj;
  }

  declare class Chat {
    public static chatListenerId: UUID
    public static override afterLoad(): void;
    public static override beforeUnload(): void;
    public static close(): void;
    public static open(task: Item): void;
    public static listMessages(task: Item): MessageObj[];
    public static postMessage(
    task: Item,
    from: UserObj,
    text: string,
    label?: string
  ): void;
    public static getDescription(task: Item): string;
    public static setDescription(task: Item, text: string): void;
    public static getSubtasks(task: Item): Checklist[];
    public static setSubtasks(task: Item, subtasks: any[]): void;
    public static addUser(task: Item, user: UserObj): void;
    public static removeUser(task: Item, user: UserObj): void;
    public static listUsers(task: Item): UserObj[];
    public static isUserInChat(task: Item, user: UserObj): boolean;
    public static scrollBottom(): void;
    public static scrollTop(): void;
    public static markRead(task: Item, user: UserObj): void;
    public static onPostMessage: (message: MessageObj) => boolean
    public static onBeforePostMessage: (task: Item, text: string) => boolean
    public static getOpenedChatId(): string | undefined;
    public static onChatChange: (id: string | undefined) => void
    public static onOpen: () => void
    public static onClose: () => void
    public static allowDescription: () => void
    public static allowChat: () => void
    public static allowEditDescription: () => void
    public static allowPostMessages: () => void
    public static onDescriptionChange: () => void
    public static onReadMessage: () => void
    public static onKeyDown: () => void
    public static onKeyUp: () => void
  }

  declare class Texts {
    public static get ru(): typeof langRu;
    public static get en(): typeof langEn;
  }

  declare type UIRenderer = (id?: string) => UIElement | undefined
  declare type ApiUiCategoryName = (typeof apiUiCategories)[number]
  declare type ApiUiCategory = ApiUiCategoryName | string

  declare class UI {
    public static onRender: (object: Item) => UIElement
    public static onDestroy: (object: Item) => UIElement
    public static get components(): UIComponents;
    public static get background(): string;
    public static set background(val: string);
    public static text(value: string): UIElement;
    public static button(props: {
    icon?: TablerIcons
    iconAfter?: TablerIcons
    title?: React.ReactNode
    hint?: React.ReactNode
    size?: 'sm' | 'md' | 'lg'
    color?: 'primary' | 'secondary' | 'notification-primary'
    disabled?: boolean
    onClick?: (e: React.MouseEvent) => void
    onMouseDown?: (e: React.MouseEvent) => void
  }): UIElement;
    public static checkbox(props: {
    value: boolean
    onChange?: (
      value: boolean,
      e?: React.MouseEvent | React.KeyboardEvent
    ) => void
    disabled?: boolean
    error?: boolean
    label?: React.ReactNode
    footnote?: React.ReactNode
    renderFullFootnote?: boolean
    className?: string
    labelClassName?: string
    dataTestId?: string
    color?: 'green' | 'blue' | 'gray'
    rounded?: boolean
    size?: CheckboxSize
  }): UIElement;
    public static icon(icon: {
    color?: keyof typeof allColors
    size?: 12 | 16 | 20 | 24 | 32
    type?: IconType
    icon: TablerIcons
    className?: string
    title?: string
    hint?: ReactNode
    style?: CSSProperties
    onClick?: (e: React.MouseEvent) => void
  }): UIElement;
    public static input(props: {
    value: string
    type?: 'number' | 'text'
    size?: 'md' | 'lg'

    onChange?: (value: string) => void
    onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void

    placeholder?: string
    autoFocus?: boolean
    isAutoWidth?: boolean

    className?: string
    inputClassName?: string
    disabled?: boolean

    textInputStyle?: Partial<CSSStyleDeclaration>
    controlled?: boolean
  }): UIElement;
    public static numberInput(props: {
    value: number
    step?: number
    min?: number
    max?: number
    onChange: (value: number) => void
    className?: string
    inputClassName?: string
    disabled?: boolean
    isPlusMinusVisible?: boolean
  }): UIElement;
    public static textarea(props: {
    textSize?: Size
    color?: Color

    autoFocus?: boolean | undefined
    placeholder?: string | undefined
    value?: string | ReadonlyArray<string> | number | undefined
    defaultValue?: string | number | ReadonlyArray<string> | undefined
    disabled?: boolean

    className?: string
    textAreaClassName?: string
    style?: React.CSSProperties

    autoComplete?: string | undefined
    allowNewLine?: boolean
    allowSoftNewLine?: boolean
    borders?: boolean
    paddings?: Paddings
    noBackground?: boolean

    onSubmit?: (api: TextAreaApi) => void
    onCancel?: (api: TextAreaApi) => void
    onFocus?: (api: TextAreaApi) => void
    onBlur?: (api: TextAreaApi) => void
    onChange?: (api: TextAreaApi) => void
    onPaste?: (api: TextAreaApi) => void
    onInit?: (element: HTMLTextAreaElement) => void

    hasError?: boolean
    isCorrect?: boolean
  }): UIElement;
    public static label(id: string, text: string): UIElement;
    public static image(src: string): UIElement;
    public static link(text: string, url: string): UIElement;
    public static linkButton(props: {
    text?: string
    size?: 'small' | 'medium' | 'big'
    icon?: TablerIcons
    className?: string
    onMouseDown?: (e: React.MouseEvent) => void
  }): UIElement;
    public static user(user: UserObj, size: number): UIElement;
    public static userSelect(param: UserSelectOptions): UIElement;
    public static columnsSelect(
    param: SelectedColumnsProps & {controlled?: boolean}
  ): UIElement;
    public static select(param: SelectWithDropdownProps): UIElement;
    public static dateInput(param: DateInputProps): UIElement;
    public static panel(): UIElement;
    public static renderReact(renderer: () => ReactElement);
    public static openPopup(
    title: string,
    element: UIElement,
    width?: number,
    props?: {
      width?: number
      subTitle?: string
      autoHeight?: boolean
      isNew?: boolean
      paddings?: 0 | 16 | 24
    }
  ): void;
    public static setTaskInfoEl(element: UIElement): void;
    public static setBoardSettingsEl(id: string, element: UIElement): void;
    public static closePopup(): void;
    public static rawHtml(html: string): UIElement;
    public static safeHtml(html: string): UIElement;
    public static selectText(element: HTMLElement): void;
    public static getRightUrl(url: string): string;
    public static setBlockVisibility(
    type: 'company-departments' | 'company-users',
    value: boolean
  ): void;
    public static override beforeUnload(): void;
    public static generateUUID(): UUID;
  }

  declare class UIHandlers {
    public static onColumnMenuShow?: (column: Item) => UIMenuItem[]
    public static onBoardSettings?: (board: Item) => BoardSettingsTab[]
    public static onTriggerTaskDone?: (task: Item) => void
  }

  declare class UIElement {
    public get style(): {[key: string]: string};
    public set style(value: {[key: string]: string});
    public get className(): string;
    public set className(value: string);
    public add(element: UIElement): void;
    public appendTo(uiElement: UIElement): void;
    public getElement(): Element;
    public query(selector: string): Element[];
    public render(el: HTMLElement, rootElement?: HTMLElement): void;
    public remove(): void;
    public clear(): void;
    public clearUiChildren(childrenName: string): void;
    public get showDefaults(): boolean;
    public set showDefaults(val: boolean);
    public get parent(): UIElement;
    public get children(): UIElement[];
    public getChildById(): UIElement;
    public refresh(): void;
    public watchMount(handler: MountListener): void;
    public onClick?: (e: MouseEvent) => boolean
    public onRender?: () => void
    public onKeyUp?: (e: MouseEvent) => void
    public onKeyDown?: (e: MouseEvent) => void
    public onUnmount?: () => void
    public isDrivenByReact: boolean
  }

  declare class Events {
    public static isShiftPressed(): boolean;
    public static isCtrlPressed(): boolean;
    public static isAltPressed(): boolean;
    public static isMetaPressed(): boolean;
    public static onKeyDown?: (e: KeyboardEvent) => void
    public static onKeyUp?: (e: KeyboardEvent) => void
    public static onClick?: (e: MouseEvent) => void
  }

  declare class Users {
    public static listAll(): UserObj[];
    public static get(emailOrId: string): UserObj;
    public static isInProject(user: UserObj, project: Item): boolean;
    public static addToProject(user: UserObj, project: Item): void;
    public static removeFromProject(user: UserObj, project: Item): void;
    public static listAllInProject(project: Item): UserObj[];
    public static getAssigned(task: Item, returnAll: boolean): UserObj | UserObj[];
    public static isUserAssigned(user: UserObj, task: Item): boolean;
    public static assignUser(user: UserObj | UserObj[], task: Item): void;
    public static addToChat(user: UserObj, task: Item): void;
    public static removeFromChat(user: UserObj, task: Item): void;
    public static isInChat(user: UserObj, task: Item): boolean;
    public static listAllInChat(task: Item): UserObj[];
    public static isHidden: (user: UserObj) => boolean
    public static onList: () => void
    public static onListInProject: () => void
    public static onListInChat: () => void
    public static onAddToProject: () => void
    public static onRemoveFromProject: () => void
    public static onAddToChat: () => void
    public static onRemoveFromChat: () => void
    public static onClick: () => void
    public static onDisplayName: () => void
  }

  declare class UserObj {
    public id: string
    public get name(): string;
    public get photo(): string;
    public get email(): string;
    public get status(): string;
    public get dndUntil(): number;
    public get lastActivity(): number;
    public get isAdmin(): boolean;
    public getRole(item: Item): string;
    public getData(): unknown;
    public setData(json: unknown): void;
  }

  declare class App {
    public static clientType(): ClientType;
    public static time(): number;
    public static lang(): Language;
    public static get theme(): 'light' | 'dark';
    public static get desktopVersion(): string | undefined;
    public static get host(): string | undefined;
    public static formatDateTime(timestamp: number, options?: any): string;
    public static saveCsv(filename: string, data: string[][], delim: string): void;
    public static saveXlsx(filename: string, data: string[][]): void;
    public static chooseFile(callback: (f: File) => void): void;
    public static chooseAndUpload(callback: (url: string) => void): void;
    public static uploadFile(file: File, callback: (url: string) => void): void;
    public static getPreviewUrl(url: string): string;
    public static httpGet(url: string, cb?: (res: HttpResp) => void): Promise<HttpResp>;
    public static httpPost(
    url: string,
    params: unknown,
    headers?: {[name: string]: string},
    cb?: (res: HttpResp) => void
  ): Promise<HttpResp>;
    public static copyToClipboard(text: string): Promise<void>;
    public static get allowUsersToInvite(): boolean;
    public static set allowUsersToInvite(value: boolean);
    public static onDisconnect: () => void
    public static onReconnect: () => void
    public static onRemoteUpdate: () => void
    public static onLocalUpdate: () => void
  }

`
